import computedStyle from 'computed-style';
import BackgroundVideo from '../../../resources/scripts/helpers/background-video';
// import YouTubeIframeLoader from 'youtube-iframe';
// import Vimeo from '@vimeo/player';
import isIEbrowser from '../../../resources/scripts/helpers/is-IE';

class BrixHero {
  static init(...parameters) {
    return new BrixHero(...parameters);
  }

  constructor(container) {
    this.container = container;
    this.animationHasRun = false;
    const IE = isIEbrowser();

    if (container) {
      //  Animation options
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      };

      const callback = (event) => {
        if (event[0].isIntersecting && !this.animationHasRun) {
          if (this.content) {
            this.content.classList.add('-finished');
            this.animationHasRun = true;
          }
        }
      };

      this.poster = container.querySelector('.image');
      this.objectFit = container.querySelector('.image.-cover');
      this.video = container.querySelector('.video');
      this.content = container.querySelector('.content');
      this.transition = false;

      if (IE) {
        this.content.style.height = computedStyle(container, 'height');
      }

      if (this.objectFit && IE) {
        window.objectFitPolyfill(this.objectFit);
      }

      for (let i = 0; i < container.classList.length; i += 1) {
        if (container.classList[i] === '-transition') {
          this.transition = true;
        }
      }

      if (this.transition && !IE) {
        if (this.poster && this.content) {
          this.content.classList.add('-transition-element');
          const observer = new IntersectionObserver(callback, options);
          observer.observe(this.poster);
        } else if (this.video && this.content) {
          this.content.classList.add('-transition-element');
          const observer = new IntersectionObserver(callback, options);
          observer.observe(this.video);
        } else if (this.content) {
          this.content.classList.add('-transition-element');
          const observer = new IntersectionObserver(callback, options);
          observer.observe(this.content);
        }
      }

      if (container) {
        const backgroundVideoWrapper = document.querySelector(`#${container.id} > .background > .video`);

        if (backgroundVideoWrapper) {
          BackgroundVideo.init(container);
        }
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-hero', BrixHero.init);
}
